<template>	
  <b-container fluid >          
    <b-row>
        <b-col>
            <b-tabs content-class="mt-3" class="mt-3">
                <b-tab title="Transacciones" active>
                    <b-row align-h="center">
                        <!-- <b-col cols="12" class="mt-3 mb-2">
                            <h5 style="color: gray; text-transform:capitalize;"><b-icon icon="files"/> Pagos</h5>
                        </b-col>  -->

                        <b-col cols="11" md="4" class="mb-2">
                            <b-form-group label="Clave:">
                                <b-form-input placeholder="Clave" v-model="clave" size="sm"></b-form-input>
                        </b-form-group>
                        </b-col>
                        <b-col cols="11" md="4" >
                            <b-form-group label="Fecha Inicial:">
                                <b-form-input size="sm"  type="date" v-model="fecInicial"  />
                            </b-form-group>
                        </b-col>
                        <b-col cols="11" md="4" >
                            <b-form-group label="Fecha Final:">
                                <b-form-input size="sm"  type="date" v-model="fecFinal"  />
                            </b-form-group>
                        </b-col>

                        <b-col cols="11" md="12" class="mt-3 ">
                            <b-button :disabled="isConsultando" @click="getTransacciones"  block variant="success"><b-spinner v-if="isConsultando"/> Consultar</b-button>
                        </b-col>
                        <b-col cols="11" md="12" class="mt-3 "  >
                            <b-table style="max-height:800px; " :items="resultados" :busy="isConsultando" :fields="fields" small striped  stacked="sm" >

                                <template #cell(show_details)="row">
                                    <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                                    {{ row.detailsShowing ? 'Ocultar' : 'Detalle'}} 
                                    </b-button>
                                    <b-button variant="info" size="sm" @click="updateStatus(row.item.id)">
                                        Actualizar Estado
                                    </b-button>
                                </template>

                                <template #row-details="row">
                                    
                                    <b-card>
                                        <b-row class="mb-2">
                                            <b-col sm="12">
                                                <h6>Solicitud</h6>
                                                <b-form-textarea
                                                :disabled="true"
                                                v-model="row.item.solicitud"
                                                rows="3"
                                                max-rows="6"
                                                ></b-form-textarea>
                                            </b-col>
                                        </b-row>

                                        <b-row class="mb-2">
                                            <b-col sm="12">
                                                <h6>Respuesta</h6>
                                                <b-form-textarea
                                                :disabled="true"
                                                v-model="row.item.respuesta"
                                                rows="3"
                                                max-rows="10"
                                                ></b-form-textarea>
                                            </b-col>
                                        </b-row>
                                    </b-card>
                                </template>
                            </b-table>
                        </b-col>
                        
                        
                    </b-row>
                </b-tab>
                <b-tab title="Cancelación Pinpad" >
                    <b-row align-h="center">
                        <!-- <b-col cols="12" class="mt-3 mb-2">
                            <h5 style="color: gray; text-transform:capitalize;"><b-icon icon="files"/> Pagos</h5>
                        </b-col>  -->
                        
                        <b-col cols="11" md="2" class="mb-2">
                            <b-form-group label="Id:">
                                <b-form-input placeholder="ID"  v-model="consecutivo" size="sm"></b-form-input>
                        </b-form-group>
                        </b-col>
                        <b-col cols="11" md="2" >
                            <b-form-group label="Referencia:">
                                <b-form-input size="sm"   v-model="referencia"  />
                            </b-form-group>
                        </b-col>
                        <b-col cols="11" md="2" >
                            <b-form-group label="Monto:">
                                <b-form-input size="sm"  v-model="monto"  />
                            </b-form-group>
                        </b-col>
                        <b-col cols="11" md="2" >
                            <b-form-group label="No. Autorización:">
                                <b-form-input size="sm"   v-model="autorizacion"  />
                            </b-form-group>
                        </b-col>
                        <b-col cols="11" md="2" >
                            <b-form-group label="Es AMEX:">
                                <b-form-checkbox  size="sm"  switch v-model="isAmex"  />
                            </b-form-group>
                        </b-col>
                        <b-col cols="11" md="2" >
                            <b-form-group label="MSI:">
                                <b-form-input  size="sm" v-model="meses"  />
                            </b-form-group>
                        </b-col>

                        <b-col cols="11" md="12" class="mt-3 ">
                            <b-button :disabled="isConsultando" @click="cancelacionPinpad"  block variant="success"><b-spinner v-if="isConsultando"/> Cancelar Transacción</b-button>
                        </b-col>
                    
                        <b-col sm="12">
                            <h6>Respuesta</h6>
                            <b-form-textarea
                            :disabled="true"
                            v-model="respuestaCancelacion"
                            rows="3"
                            max-rows="10"
                            ></b-form-textarea>
                        </b-col>
                                        
                        
                    </b-row>
                </b-tab>
                <b-tab title="Configuración">
                    <b-row ><b-col >
                        <h6>Timeout:</h6> <b-form-input class="mt-2" v-model="timeOutMonitor">
                            </b-form-input> <b-button size="sm" >Actualizar</b-button> </b-col></b-row>
                    <ConfigPinpad :timeout="timeOutMonitor"/>
                    <b-row class="mt-2"></b-row>
                </b-tab>
            </b-tabs>

            
        </b-col>
    </b-row>

    <b-modal hide-footer header-bg-variant="dark" title="Cancelación" v-model="showModalRespuestaC" header-text-variant="light">
        <b-row>
            <b-col cols="12"><h6>{{statusCancelacion}}</h6></b-col>
            <b-col v-if="pdfGenerated!=null && pdfGenerated!=''">
                <b-embed id="embed1" type="iframe" :src="'data:application/pdf;base64,' + pdfGenerated"></b-embed>
            </b-col>
        </b-row>
    </b-modal>

   
  </b-container>
</template>

<script>
    import { mapState} from 'vuex'
    import axios from 'axios'
    import { server, getGetConfig,  getPostConfig, handledError , checkAuth} from '@/axios-tools'
    import ConfigPinpad from './ConfigPinpad.vue';

    export default {
        computed: {
            ...mapState({
            token: state => state.login.token,
            
        }),
            timeOutMonitor: {
                get(){return this.$store.state.cobro.timeOutMonitor},
                set(v){this.$store.commit("updateTimeOutMonitor", v);}
            }
        }
        ,
        components:{ConfigPinpad},
        data(){
            return{
                
                isConsultando : false,
                clave:"",
                fecInicial:null,
                fecFinal:null,
                resultados:[],
                fields: ['id', 'fecha', 'movimiento' ,'show_details'],

                consecutivo:'',
                referencia:'',
                autorizacion:'',
                monto:'',
                isAmex:false,
                meses:'',
                respuestaCancelacion:'',

                statusCancelacion:'',
                pdfGenerated:'',

                showModalRespuestaC : false
            }
        },
       
        methods: {
            
            getTransacciones(){
                
                this.resultados=[];
                if(!this.isConsultando && checkAuth(this.$router, this.$store)){
                    
                   this.isConsultando=true;
                    const solicitud = {
                            "c" : this.clave,
                            "fechaIni" : this.fecInicial,
                            "fechaFin" : this.fecFinal,
                            
                        }

                    axios(
                        
                        getGetConfig(server.transacciones3D, {}, this.token, solicitud)
                    )
                    .then(res => {
                        this.resultados = res.data;
                        
                        this.isConsultando = false;
                        
                    }).catch(err => {
                        this.isConsultando = false;
                        handledError(err, server.transacciones3D, this.$router, this.$store);
                    });
                }
            },
            cancelacionPinpad(){
                
                this.respuestaCancelacion='';
                this.statusCancelacion='';
                this.pdfGenerated='';

                if(!this.isConsultando &&  checkAuth(this.$router, this.$store)){
                    this.isConsultando=true;
                
                    const params ={
                        "id" : this.consecutivo,
                        "referencia" : this.referencia,
                        "autorizacion" : this.autorizacion,
                        "monto" : this.monto,
                    }
                    axios(
                        getPostConfig(server.genct3pinpad, {}, this.token, params)
                    ).then(resT3 => {
                        const formPP = {
                            "adq" : resT3.data.config.adq,
                            "action": "CANCELACION",
                            "monto" : this.monto,
                            "concecutivo" : this.consecutivo,
                            "referencia" : this.referencia,
                            "autorizacion" : this.autorizacion,
                            "isAmex" : this.isAmex,
                            "sucursal" : resT3.data.config.sucursal,
                            "entidad" : resT3.data.config.entidad,
                            "correoComercio" : resT3.data.config.correoComercio,
                            "concepto" : resT3.data.config.concepto
                        }
                        const config = getPostConfig(server.cobroPinpad, formPP, null , null);
                        config.headers = { 
                            'Content-Type': 'application/json'
                        };
                        axios(
                            config
                        ).then(resPinpadObject => {
                            
                             let esObjeto = typeof resPinpadObject.data == 'object';
                            let resPinpad = esObjeto ? JSON.stringify(resPinpadObject.data) : resPinpadObject.data.replace(/\|/g, '\n').replace('&', '\n');

                            this.pdfGenerated = esObjeto && resPinpadObject.data.pdfBase64!=null ? resPinpadObject.data.pdfBase64 : "";
                            this.showModalRespuestaC = true;
                            this.statusCancelacion= esObjeto ? resPinpadObject.data.status : resPinpad;


                            this.respuestaCancelacion = resPinpad;
                            //Actualizar respuesta
                            axios(
                                getPostConfig(server.updct3pinpad, { response:resPinpad.data}, this.token , {id:resT3.data.idT3D, referencia:this.referencia})
                            ).then( ()=> {
                                this.isConsultando=false;
                                                               
                            }).catch(err => {
                                this.isConsultando=false;
                                alert(err);
                            })
                               
                           
                        }).catch(err => {
                            this.isConsultando=false;
                            alert(err);
                        })
                    }).catch(err => {
                        this.isConsultando=false;
                        alert(err);
                    })
                
            }
            },
            updateStatus(id){
                
                if(!this.isConsultando && checkAuth(this.$router, this.$store)){
                    
                    axios(
                        
                        getGetConfig(server.updateTransaccion3D, {}, this.token, {id:id})
                    )
                    .then(res => {
                        alert(res.data);
                        
                        this.isConsultando = false;
                        
                    }).catch(err => {
                        this.isConsultando = false;
                        handledError(err, server.transacciones3D, this.$router, this.$store);
                    });
                }
            }
           
        },
       
    }
</script>
<style>
div.error    {color: red;}
</style>